"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genericSortByFn = void 0;
var genericSortByFn = function genericSortByFn(propertyKey) {
  return function (a, b) {
    if (a[propertyKey] > b[propertyKey]) {
      return 1;
    } else if (a[propertyKey] < b[propertyKey]) {
      return -1;
    } else {
      return 0;
    }
  };
};
exports.genericSortByFn = genericSortByFn;